<template>
  <div>
    <form role="form" name="myForm" @submit.prevent="FogotPasswod">
      <div class="box" style="margin-top:150px;width:520px;">
        <header class="head">
          <div align="center">
            <img style="margin-top:-80px;" src="../../assets/imgs/logo.png" />
          </div>
          <h1>Authentication</h1>
        </header>

        <input
          type="text"
          class="username"
          :class="{
            'input-validation-error':
              EmailFlags.invalid && !EmailFlags.pristine,
          }"
          name="Email"
          placeholder="Email Address"
          style="margin-left:30px;"
          v-model="Email"
          v-validate="'required|email'"
          autocomplete="off"
          autofocus
        />
        <div>
          <div
            v-bind:id="'g_recaptcha'"
            class="g-recaptcha"
            style="align-items: center;"
          ></div>
        </div>
        <span
          class="text-danger"
          style="margin-left:30px;"
          v-if="errors.first('CAPTCHA')"
          >{{ errors.first("CAPTCHA") }}</span
        >
        <div class="row">
          <loading v-if="loading"></loading>
          <div class="col-md-8" style="margin-left:30px;">
            <input
              type="submit"
              class="login-button"
              value="Retrieve My Password"
            />

            <input
              type="button"
              class="login-button"
              style="margin-left:5px;"
              @click="GoBack"
              value="Back"
            />
          </div>
        </div>
        <br />

        <div
          v-if="successMessage != '' && successMessage != null"
          class="alert alert-success text-center"
        >
          <strong>{{ successMessage }}</strong>
        </div>

        <div
          v-if="errorMessage != '' && errorMessage != null"
          class="alert alert-danger text-center"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
        <div
          v-if="error != '' && error != null"
          class="alert alert-danger text-center"
        >
          <strong>{{ error }}</strong>
        </div>
      </div>
    </form>
  </div>
</template>
<style>
.g-recaptcha {
  display: inline-block;
  align-content: center;
  padding-left: 18%;
  margin-bottom: 15px;
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vee-validate";
import * as ACTIONS from "../../store/actions";
import { LOCALPC, LOCALNETWORK, UAT, LIVE } from "../../services";
export default {
  data() {
    return {
      successMessage: "",
      Email: null,
      error: null,
      // sitekeyLive: "",
      // sitekeyLocalNetwork: "",
      // sitekeyUat: "6LdWA68UAAAAAPUmiDgNBIre97ZbHCXm3zSmyh60", //UAT
      // sitekeyLocal: "6Lc4Eq4UAAAAAAQLJ6IAkpmYjVFeqHkhrF-1EVPu" //LOCAL };
    };
  },
  methods: {
    GoBack() {
      this.$router.push("/Login");
    },
    FogotPasswod() {
      this.error = "";
      this.$validator.errors.remove("CAPTCHA");
      var response = grecaptcha.getResponse();
      if (response == null || response == "") {
        this.$validator.errors.add({
          field: "CAPTCHA",
          msg: "Please verify captcha",
        });
        this.$validator.validateAll().then((res) => {
          if (res) {
          } else {
            this.error = "Provide Correct Details";
            setTimeout(function() {
              vm.error = null;
            }, 1800);
          }
        });
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          //let query = "?Email=" + this.Email;
          var vm = this;
          //var response = grecaptcha.getResponse();
          var params = new URLSearchParams();
          params.append("Email", this.Email);
          params.append("Captcha", response);
          this.$store
            .dispatch(ACTIONS.FORGOT_PASSWORD, params)
            .then((res) => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.successMessage =
                  "Please Check Email. Reset link sent to your Registered Email Address";
                vm.Email = null;

                setTimeout(function() {
                  //vm.errors.clear();
                  vm.errors.remove("Email");

                  vm.successMessage = null;
                }, 2200);
              }
            })
            .catch((err) => {
              var vm = this;
              this.error = "Please contact Adminitrator";
              setTimeout(function() {
                vm.error = null;
              }, 2200);
            });
        } else {
          this.error = "Provide Correct Details";
          setTimeout(function() {
            vm.error = null;
          }, 1800);
        }
      });
    },
  },
  mounted() {
    var key = this.SiteKey; // "6LfpNtQUAAAAAAB6dBaJ9c-8NsSwKYIbZ0-LfDI5";
    // if (Boolean(LIVE)) {
    //   key = this.sitekeyLive;
    // } else if (Boolean(UAT)) {
    //   key = this.sitekeyUat;
    // } else if (Boolean(LOCALNETWORK)) {
    //   key = this.sitekeyLocalNetwork;
    // } else {
    //   key = sitekeyLocal;
    // }
    //var key = this.sitekey;
    //setTimeout(function() {
    var d = document.getElementById("g_recaptcha");
    grecaptcha.render("g_recaptcha", {
      sitekey: key,
    });
    //  }, 600);
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      errorMessage: "error",
      SiteKey: "GetSiteKey",
    }),
    ...mapFields({
      EmailFlags: "Email",
    }),
  },
};
</script>
